<template>
  <!-- Top header -->

  <header>
    <div class="bd-header">
      <!-- header bottom area start -->
      <div id="header-sticky" class="bd-header-bottom-2">
        <!-- header bottom clip shape  -->
        <div class="bd-header-bottom-clip-shape"></div>
        <div class="container">
          <div class="mega-menu-wrapper p-relative">
            <div class="d-flex align-items-center justify-content-between">
              <div class="bd-header-logo">
                <a href="/">
                  <img src="/img/logo/Baburam School Logo.png" alt="logo">
                </a>
              </div>
              <div class="bd-main-menu d-none d-lg-flex align-items-center">
                <nav id="mobile-menu">
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li class="has-dropdown">
                      <a href="#">About</a>
                      <ul class="submenu">
                        <li><router-link to="/about">About School</router-link></li>
                        <li><a href="https://vedantafoundation.org/">About Foundation</a></li>
                        <li><router-link to="/leadership">Leadership Message</router-link></li>
                        <li><router-link to="/principal">Principal's Message</router-link></li>
                        <li><router-link to="/staff">Staff</router-link></li>
                        <li><router-link to="/campus">Campus</router-link></li>

                      </ul>
                    </li>
                    <li class="has-dropdown">
                      <a href="#">Academics</a>
                      <ul class="submenu">
                        <li><router-link to="/preprimary">Class Play Group - II</router-link></li>
                        <li><router-link to="/primary">Class III to V</router-link></li>
                        <li><router-link to="/secondary">Class VI to VIII</router-link></li>
                        <li><router-link to="/highersecondary">Class IX to XII</router-link></li>
                      </ul>
                    </li>
                    <li class="has-dropdown">
                      <a href="#">Admission</a>
                      <ul class="submenu">
                        <li><router-link to="/admission">Admission Process</router-link></li>
                        <li><router-link to="/fees">Fee Structure</router-link></li>
                        <li><router-link to="/scholarship">Scholarships</router-link></li>
                        <li><a href="/img/general/vgps_brochure.pdf">School Brochure</a></li>
                      </ul>
                    </li>
                    <li class="has-dropdown">
                      <a href="#">Activities</a>
                      <ul class="submenu">
                        <li><router-link to="/houses">Houses</router-link></li>
                        <li><router-link to="/extracurricular">Extracurricular</router-link></li>
                      </ul>
                    </li>
                    <li class="has-dropdown">
                      <a href="#">Media</a>
                      <ul class="submenu">
                        <li><router-link to="/gallery">Gallery</router-link></li>
                        <li><a href="https://bpr.eshala.co.in/events">Events</a></li>
                        <li><a href="https://bpr.eshala.co.in/page/news">News</a></li>
                        <li><a href="https://bpr.eshala.co.in/page/notices">Notices</a></li>
                      </ul>
                    </li>
                    <li>
                      <router-link to="/contact">Contact</router-link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="bd-header-bottom-right d-flex justify-content-end align-items-center">
                <div class="bd-header-btn d-none d-xl-block">
                  <a href="donate.html" class="bd-btn">
                    <span class="bd-btn-inner">
                      <span class="bd-btn-normal">Contribute</span>
                      <span class="bd-btn-hover">Contribute</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- header bottom area end -->
    </div>
  </header>

</template>

<script>
// import Menubar from "primevue/menubar";

export default {
  name: "AppHeader",
  components: {
    // Menubar,
  },
  data() {
    return {
      items: [
        {
          label: "Home",
          route: "/",
        },
        {
          label: "About us",
          items: [
            {
              label: "About School",
              route: "/about",
            },
            {
              label: "Vedanta Foundation",
              route: "https://vedantafoundation.org/",
            },
            {
              label: "Leadership Message",
              route: "/",
            },
            {
              label: "Principal's Message",
              route: "/",
            },
            {
              label: "Staff",
              route: "/",
            },
            {
              label: "Campus",
              route: "/",
            }
          ],
        },
        {
          label: "Academics",
          items: [
            {
              label: "Class Playgroup - II",
              route: "/",
            },
            {
              label: "Class III - V",
              route: "/",
            },
            {
              label: "Class VI - VIII",
              route: "/",
            },
            {
              label: "Class IX - XII",
              route: "/",
            },
            {
              label: "Board Results",
              route: "/",
            }
          ],
        },
        {
          label: "Admission",
          items: [
            {
              label: "Admission Process",
              route: "/",
            },
            {
              label: "Fee Structure",
              route: "/",
            },
            {
              label: "Scholarship",
              route: "/",
            },
            {
              label: "School Brochure",
              route: "/",
            }
          ],
        },
        {
          label: "Activities",
          items: [
            {
              label: "Houses",
              route: "/",
            },
            {
              label: "Extracurricular",
              route: "/",
            },
          ],
        },
        {
          label: "Media",
          items: [
            {
              label: "Gallery",
              route: "/",
            },
            {
              label: "Events",
              route: "/",
            },
            {
              label: "News",
              route: "/",
            },
            {
              label: "Notices",
              route: "/",
            }
          ],
        },
        {
          label: "Contact",
          route: "/",
        },

      ],
      marqueeItems: [
        {
          id: 1,
          text: "Applications now open for aspiring students for AY 2025-2026. Apply Now.",
        },
      ],
    };
  }
};
</script>
<style>
.p-menubar {
  border: 0;
  padding: 20px;
  font-size: 16px;
  color: #ffffff;
  position: relative;
  font-weight: 600;
  background-color: white;
}

.p-menubar-root-list {
  margin: 0;
}

.p-submenu-list {
  margin: 0;
  padding: 0;
  z-index: 1000;
}

.p-menuitem-link {
  color: #111d5e;
}
</style>
<!-- // 5EHMZ8XMM3q7WQ4Kh77j -->
